import React from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';

const StatisticsCards = ({ stats }) => {
  return (
    <Row className="mb-4">
      <Col md="4">
        <Card className="border-0 shadow-sm">
          <CardBody className="text-center">
            <h2 className="text-primary mb-2">{stats.total}</h2>
            <p className="text-muted mb-0">Tổng người dùng</p>
          </CardBody>
        </Card>
      </Col>
      <Col md="4">
        <Card className="border-0 shadow-sm">
          <CardBody className="text-center">
            <h2 className="text-success mb-2">{stats.followed}</h2>
            <p className="text-muted mb-0">Đã follow OA</p>
          </CardBody>
        </Card>
      </Col>
      <Col md="4">
        <Card className="border-0 shadow-sm">
          <CardBody className="text-center">
            <h2 className="text-danger mb-2">{stats.notFollowed}</h2>
            <p className="text-muted mb-0">Chưa follow OA</p>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default StatisticsCards;

